import type { FC, ReactNode } from 'react';

import ChevronIcon from '@zen/Components/Icons/ChevronIcon';
import { CollapsibleElement } from '@zen/DesignSystem';
import { useCollapsibleElement } from '@zen/utils/hooks/useCollapsibleElement';

import type { SidebarCounters, SidebarLink } from '../../types';
import NavLink from '../NavLink';

interface Props {
  counters: SidebarCounters;
  item: SidebarLink;
}

const NavSection: FC<Props> = ({ counters, item }) => {
  const { children, isExpandedByDefault, label } = item;
  const [isExpanded, setIsExpanded] = useCollapsibleElement(label, isExpandedByDefault, 'sidebar-nav-config');

  const handleClick = (): void => setIsExpanded(!isExpanded);

  const renderLink = (link: SidebarLink): ReactNode => <NavLink key={link.label} counters={counters} item={link} />;

  return (
    <div data-component="nav-section">
      <button
        aria-expanded={isExpanded}
        className="flex items-center w-full py-1.5 pl-6 pr-1 text-base leading-normal cursor-pointer text-grey-base xl:text-sm"
        onClick={handleClick}
        type="button"
      >
        <span>{label}</span>
        <ChevronIcon className="ml-auto mr-2 text-lg" expanded={isExpanded} size="small" />
      </button>
      <CollapsibleElement isOpened={isExpanded}>{children?.map(renderLink)}</CollapsibleElement>
    </div>
  );
};

export type { Props as NavSectionProps };

export default NavSection;
